var ViewPortModel = (function () {
    function ViewPortModel() {
        this._showDebug = false;
    }
    ViewPortModel.prototype.log = function (out) {
        if (this._showDebug) {
            console.log(out);
        }
    };
    return ViewPortModel;
}());
export { ViewPortModel };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmlldy1wb3J0LW1vZGVsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidmlldy1wb3J0LW1vZGVsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBO0lBQUE7UUFDRSxlQUFVLEdBQVksS0FBSyxDQUFDO0lBaUI5QixDQUFDO0lBZkMsMkJBQUcsR0FBSCxVQUFJLEdBQVE7UUFDVixFQUFFLENBQUEsQ0FBQyxJQUFJLENBQUMsVUFBVSxDQUFDLENBQUMsQ0FBQztZQUNuQixPQUFPLENBQUMsR0FBRyxDQUFDLEdBQUcsQ0FBQyxDQUFDO1FBQ25CLENBQUM7SUFDSCxDQUFDO0lBV0gsb0JBQUM7QUFBRCxDQUFDLEFBbEJELElBa0JDIn0=